import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/organize-pdf/components/OrganizePDFUploader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/PDFToolContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Breadcrumbs.tsx");
